import React, { memo, Fragment } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { useValues } from '@redlink/assets/values';
import { useLocale } from '@redlink/assets/locale';
import { Space } from '@redlink/components/atoms';
import { Button } from '@redlink/components/molecules';

export const LinkTemplateActions = memo(
  ({ selectedItemIndex, onItemPressed }) => {
    const { styles } = useStyle();
    const { dictionary } = useLocale();
    const { staticData } = useValues();

    return (
      <View style={styles.actionsContainer}>
        {staticData.linkTemplates.map(({ title }, index) => {
          const isSelected = index === selectedItemIndex;
          return (
            <Fragment key={index}>
              <Button
                variant={isSelected ? 'primary' : 'gray'}
                title={dictionary[title]}
                style={styles.button}
                onPress={() => onItemPressed(title, index)}
              />
              <Space size={8} />
            </Fragment>
          );
        })}
      </View>
    );
  }
);

const useStyle = createUseStyle(() => ({
  actionsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 12,
  },
  button: {
    height: 32,
    paddingHorizontal: 8,
    marginVertical: 4,
    borderRadius: 10,
  },
}));
